import Image from 'react-bootstrap/Image';

function MozgasbanAzElet() {
    return (
        <div className="kb-article-body">
            <p>
                Az emberi test mozgásra lett tervezve. Amikor rendszeresen edzünk, a szervezetünk nem csupán
                kalóriát éget el, hanem sejtszinten újrahuzalozza önmagát. Ezzel szemben a tartós tétlenség,
                az úgynevezett <strong>hipokinézia</strong> (mozgásszegény állapot) csendes rombolást végez a
                szervezetben.
            </p>

            <section className="kb-section">
                <h2>1. Szív és Keringés: A belső motor karbantartása</h2>
                <Image src="/pictures/tudasbazis/mozgasban-az-elet/Pict01.jpeg" fluid rounded className="kb-section-image" />
                <p>
                    A szív izomszövet, amely pontosan úgy reagál az edzésre, mint bármelyik más izmunk:
                    alkalmazkodik és megerősödik.
                </p>
                <ul className="kb-effect-list">
                    <li>
                        <strong>A mozgás hatása:</strong>
                        <ul>
                            <li>
                                Nő a szív <strong>lökettérfogata</strong> (az az egyetlen összehúzódással
                                kilökött vérmennyiség), így a szívnek kevesebbszer kell dobbannia nyugalomban,
                                hogy ellássa a testet oxigénnel.
                            </li>
                            <li>
                                Fokozódik az <strong>angiogenezis</strong> (új, hajszálvékony vérerek,
                                úgynevezett kapillárisok képződése az izmokban), ami megkönnyíti a vér
                                áramlását és csökkenti a vérnyomást.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>A mozgáshiány ára:</strong> Az érfalak veszítenek rugalmasságukból, a nyugalmi
                        pulzus megemelkedik, a szív pedig állandó túlterhelés alatt dolgozik.
                    </li>
                </ul>

                <div className="kb-table-wrap">
                    <table className="kb-table">
                        <thead>
                            <tr>
                                <th>Élettani terület</th>
                                <th>Utánpótlás korosztály (7–14 év)</th>
                                <th>Felnőttek és 50+ korosztály</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Élettani terület">Rendszeres mozgással</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Nagyobb állóképesség, egészséges keringési alapok felnőttkorra.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Alacsonyabb vérnyomás, csökkenő infarktus- és érelmeszesedés-kockázat.
                                </td>
                            </tr>
                            <tr>
                                <td data-label="Élettani terület">Mozgáshiány esetén</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Korai érfal-merevedés, fáradékonyság már minimális lépcsőzéskor is.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Magas vérnyomás, emelkedett koleszterinszint, keringési túlterheltség.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="kb-section">
                <h2>2. Csontok és Ízületek: A vázrendszer védelme</h2>
                <Image src="/pictures/tudasbazis/mozgasban-az-elet/Pict02.jpeg" fluid rounded className="kb-section-image" />
                <p>
                    A csontok nem merev, élettelen képződmények, hanem folyamatosan átépülő élő szövetek.
                </p>
                <ul className="kb-effect-list">
                    <li>
                        <strong>A mozgás hatása:</strong>
                        <ul>
                            <li>
                                A talajjal való érintkezés és a dinamikus mozdulatok mechanikai ingert adnak a
                                csontoknak. Ez a terhelés munkára bírja az <strong>osteoblastokat</strong>{' '}
                                (csontépítő sejteket), amelyek beépítik a kalciumot a csontmátrixba.
                            </li>
                            <li>
                                Az ízületekben megnő a <strong>synovia</strong> (ízületi folyadék vagy
                                „ízületi kenőanyag") termelődése, ami táplálja az egyébként saját vérellátással
                                nem rendelkező porcokat.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>A mozgáshiány ára:</strong> A csontok ásványianyag-tartalma csökkenni kezd, a
                        porcok „kiszáradnak", rugalmatlanná válnak és fokozott kopásnak indulnak.
                    </li>
                </ul>

                <div className="kb-table-wrap">
                    <table className="kb-table">
                        <thead>
                            <tr>
                                <th>Élettani terület</th>
                                <th>Utánpótlás korosztály (7–14 év)</th>
                                <th>Felnőttek és 50+ korosztály</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Élettani terület">Rendszeres mozgással</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Csúcscsonttömeg (maximális elérhető csontsűrűség) megalapozása.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Megelőzi a szarkopéniát (izomtömeg-vesztést) és az osteoporosist
                                    (csontritkulást).
                                </td>
                            </tr>
                            <tr>
                                <td data-label="Élettani terület">Mozgáshiány esetén</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Hanyagtartás, lúdtalp, gyenge vázizmok, amelyek nem tartják meg a gerincet.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Krónikus derékfájás, porckorongsérv-kockázat, instabil, sérülékeny
                                    ízületek.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="kb-section">
                <h2>3. Anyagcsere és Hormonok: Belső egyensúlyunk védőbástyája</h2>
                <Image src="/pictures/tudasbazis/mozgasban-az-elet/Pict03.jpeg" fluid rounded className="kb-section-image" />
                <p>
                    Minden alkalommal, amikor az izmaink összehúzódnak, biokémiai gyárként kezdenek működni.
                </p>
                <ul className="kb-effect-list">
                    <li>
                        <strong>A mozgás hatása:</strong>
                        <ul>
                            <li>
                                Az összehúzódó izomzat azonnal mozgósítja a{' '}
                                <strong>GLUT4 transzporter fehérjéket</strong> (a sejtek cukorkapuit), amelyek
                                inzulin nélkül is képesek kivonni a felesleges szőlőcukrot a vérből.
                            </li>
                            <li>
                                Az izmok gyulladáscsökkentő anyagokat, úgynevezett <strong>miokineket</strong>{' '}
                                választanak ki a véráramba, amelyek semlegesítik a szervezetben zajló rejtett
                                gyulladásokat.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>A mozgáshiány ára:</strong> Kialakul az <strong>inzulinrezisztencia</strong>{' '}
                        (amikor a sejtek érzéketlenné válnak az inzulinra, a cukor pedig a vérben reked), ami
                        egyenes út a 2-es típusú cukorbetegséghez és a zsigeri (belső szervek körüli) zsírok
                        lerakódásához.
                    </li>
                </ul>

                <div className="kb-table-wrap">
                    <table className="kb-table">
                        <thead>
                            <tr>
                                <th>Élettani terület</th>
                                <th>Utánpótlás korosztály (7–14 év)</th>
                                <th>Felnőttek és 50+ korosztály</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Élettani terület">Rendszeres mozgással</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Kiegyensúlyozott anyagcsere, stabil energiaszint az iskolai órákon.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Hatékony zsíranyagcsere, stabil vércukor, mélyebb és pihentetőbb alvás.
                                </td>
                            </tr>
                            <tr>
                                <td data-label="Élettani terület">Mozgáshiány esetén</td>
                                <td data-label="Utánpótlás korosztály (7–14 év)">
                                    Gyermekkori elhízás, korai anyagcserezavarok, délutáni
                                    energia-összeomlások.
                                </td>
                                <td data-label="Felnőttek és 50+ korosztály">
                                    Metabolikus szindróma, állandó fáradtságérzet, lassú regeneráció.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default MozgasbanAzElet;
